const files = [
  {
    file: 'ssl',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/ssl',
  },
  {
    file: 'access-logs',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/access-logs',
  },
  {
    file: 'public_html',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/public_html',
  },
  {
    file: 'www',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/www',
  },
  {
    file: 'etc',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/etc',
  },
  {
    file: 'mail',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/mail',
  },
  {
    file: 'public_ftp',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/public_ftp',
  },
  {
    file: 'perl5',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/perl5',
  },
  {
    file: 'logs',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/logs',
  },
  {
    file: 'tmp',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/tmp',
  },
  {
    file: 'ifw.xze.mybluehost.me',
    size: 4096,
    type: 'dir',
    path: '/home2/ifwxzemy/ifw.xze.mybluehost.me',
  },
];

export default files;
